
<template>
  <v-menu offset-y offset-x :close-on-content-click="false" width="300px" v-model="menu">
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        dot bottom bordered
        color="error"
        overlap
        :value="(menu && apply) || is_active"
      >
        <v-btn x-small :color="icon_color"  :class="null" icon v-bind="attrs" v-on="on" >
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <v-list dense width="300px">
      <v-list-item>
        <v-list-item-title> {{$t('filters')}}: {{ header.text }} </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="use_search">
        <v-list-item-content> 
          <v-list-item-title> {{$t('searching')}} </v-list-item-title>
          <v-list-item-title> 
            <v-text-field dense filled small hide-details v-model="search" ></v-text-field>
          </v-list-item-title>
        </v-list-item-content> 
      </v-list-item>

      <v-list-item v-if="use_options">
        <v-list-item-content> 
          <!-- <v-list-item-title> {{header.text}} </v-list-item-title> -->
          <v-list-item-title> 
            <v-select
              :items="options" dense hide-details
              v-model="search"
              :multiple="use_multiple"
              filled item-text="text" item-value="value"
            ></v-select>
          </v-list-item-title>
        </v-list-item-content> 
      </v-list-item>
      
      <v-list-item v-if="use_date">
        <v-list-item-content> 
          <!-- <v-list-item-title> {{header.text}} </v-list-item-title> -->
          <v-list-item-title> 
            <date-picker class="pt-1"
              dense filled min="1999-12-12" hide-details
              :label="$t('since')"
              @datePicked="handleStartPicked"
            ></date-picker>
          </v-list-item-title>
        </v-list-item-content> 
      </v-list-item>
      <v-list-item v-if="use_date">
        <v-list-item-content> 
          <!-- <v-list-item-title> {{header.text}} </v-list-item-title> -->
          <v-list-item-title> 
            <date-picker class="pt-1"
              dense filled min="1999-12-12" hide-details
              :label="$t('until')"
              @datePicked="handleEndPicked"
            ></date-picker>
          </v-list-item-title>
        </v-list-item-content> 
      </v-list-item>

      <v-list-item v-if="use_sort">
        <v-list-item-content> 
          <v-list-item-title> {{$t('ordering')}} </v-list-item-title>
          <v-list-item-title> 
            <v-select
              :items="sorts" dense hide-details
              v-model="sort_dir"
              filled item-text="text" item-value="value"
            ></v-select>
          </v-list-item-title>
        </v-list-item-content> 
      </v-list-item>
      <v-list-item>
        <v-list-item-content> 
          <v-btn small outlined color="primary" @click="applyFilter()">{{$t('apply')}}</v-btn>
          <!-- <v-list-item-title>  </v-list-item-title> -->
        </v-list-item-content> 
      </v-list-item>
      <v-list-item>
        <v-list-item-content> 
          <v-btn small text color="error" @click="clearFilter()">{{ $t('clear') }}</v-btn>
          <!-- <v-list-item-title>  </v-list-item-title> -->
        </v-list-item-content> 
      </v-list-item>
      <!-- <v-list-item v-for="(item, key) in codes" :key="key" >
        <v-list-item-icon class="mr-2">
          <v-icon small :color="showStatus({status: key}).color">mdi-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item }}</v-list-item-title>
        <v-divider></v-divider>
      </v-list-item> -->
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'SortFilterTable',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  props: {
    header: {
      type: Object
    },
    use_date: {
      type: Boolean,
      default: false,
    },
    use_sort: {
      type: Boolean,
      default: true,
    },
    use_search: {
      type: Boolean,
      default: true,
    },
    use_options: {
      type: Boolean,
      default: false,
    },
    use_multiple: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array
    },
    operator: {
      type: String,
      default: '_i_cont_any'
    },
  },
  data() {
    return {
      menu: false,
      search: null,
      sort_dir: null, // 'asc' 'desc'
      sorts: [
        {text: 'Crescente', value: 'asc'},
        {text: 'Decrescente', value: 'desc'},
      ],
      search_start: null,
      search_end: null,
      apply: false,
      bkp_filter: {
        search_start: null,
        search_end: null,
        search: null,
        sort_dir: null,
      }
    }
  },
  methods: {
    handleStartPicked(e){
      this.search_start = e
    },
    handleEndPicked(e){
      this.search_end = e
    },
    cancel(){
      this.search = this.bkp_filter.search || null
      this.search_start = this.bkp_filter.search_start || null
      this.search_end = this.bkp_filter.search_end || null
      this.sort_dir = this.bkp_filter.sort_dir || null
    },
    clearFilter(){
      this.setBkp(true)
      this.cancel()
      this.apply = false
      this.emit()
    },
    setBkp(to_null = false){
      this.bkp_filter = {
        search_start: to_null ? null : this.search_start,
        search_end: to_null ? null : this.search_end,
        search: to_null ? null : this.search,
        sort_dir: to_null ? null : this.sort_dir,
      }
    },
    applyFilter(){
      this.apply = true
      this.setBkp()
      this.emit()
    },
    emit() {
      let obj = {}
      // obj[`${this.header.value}_i_cont_any`] = this.search
      // obj[`${this.header.value}_sort`] = `${this.header.value} ${this.sort_dir}`

      const {value, search_field} = this.header

      obj.searches = {}
      if (this.use_search || this.use_options){
        obj.searches[`${search_field || value}${this.operator||'_i_cont_any'}`] = this.search
      } else if (this.use_date){
        obj.searches[`${search_field || value}_gteq_any`] = this.search_start
        obj.searches[`${search_field || value}_lteq_any`] = this.search_end
      }
      
      obj.sorts = {}
      if (this.use_sort){
        obj.sorts[`${search_field || value}`] = this.sort_dir
      }
      // if (this.sort_dir){
        // obj.sorts = [`${this.header.value} ${this.sort_dir}`]
      // }

      // obj[this.header.value] = {
      //   query: this.search,
      //   query_field: this.header.value,
      //   sort_dir: this.sort_dir,
      //   sort_field: this.header.value,
      // }
      this.$emit('sentFilter', obj )
      this.menu = false
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    is_active(){
      return this.apply && !!this.search || !!this.sort_dir || !!this.search_start || !!this.search_end 
    },
    icon_color(){
      return this.is_active? 'primary' : 'blue-grey'
    },
    btn_color(){
      return this.is_active? 'primary' : 'white'
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    menu(nv,ov) {
      if (nv){
        if (this.apply == true){
          this.setBkp()
        }
      } else if (nv == false){
        if (this.apply == true) {
          this.cancel()
        }
      }
    }
  },
}
</script>

<style scoped>

</style>